module.exports = __webpack_public_path__ + "img/doorLogo32.30eafa89.png";